export default (node => {
  var Data = JSON.parse(node.getAttribute('data-tabs'));
  return {
    Data: Data ? Data : null
  };
});